import { ErrorMessage } from '../../helpers/security/security';
import featureFlagService from '../../services/featureFlag.service';

const queryHighestSupportedApplicationMilestone = async (dealerId: number) => {
  try {
    const { data } = await featureFlagService.highestSupportedApplicationMilestone(dealerId);

    return data?.highestSupportedApplicationMilestone ?? 0;
  } catch (err: any) {
    const error: ErrorMessage = {
      stackTrace: err,
      displayText: 'Unable to fetch highest supported application milestone',
    };

    throw error;
  }
};

export default queryHighestSupportedApplicationMilestone;
